<template>
  <FormBlock>
    <TextField
      v-model="address"
      :label="$tt(`expected_stay_address_${country}`)"
      :hint="$tt('hotel_name_address')"
      :rules="required ? [requiredRule] : []"
      append-inner-icon="mdi:bed"
      persistent-hint
    />
  </FormBlock>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';

const country = inject(countryKeyInjectionKey)!;

const address = defineModel<string>({ required: true });
defineProps<{
  required?: boolean;
}>();

const requiredRule = useValidation().required;
</script>